import React from 'react';
import { Grid } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SectionBox } from "src/pages/sistema/components/FieldView";
import { OperacionLCLS } from "../types/types";
import { OperacionLCLSFields } from '../types/fields';
import { dateFormatter } from "src/utils/formatters";

type SeccionLCLSDatosOperacionProps = {
    operacion?: OperacionLCLS;
}

const SeccionLCLSDatosOperacion = ({ operacion }: SeccionLCLSDatosOperacionProps) => {
    return (
        <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
            {operacion && (
                <SectionBox>
                    <Grid item xs={12} md={2}>
                        <FieldView label='País' value={operacion[OperacionLCLSFields.NombrePais]} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FieldView
                            label='Usuario Alta'
                            value={`${operacion[OperacionLCLSFields.NombreUsuarioAlta]} ${operacion[OperacionLCLSFields.ApellidoUsuarioAlta]}`}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FieldView label='Unidad de Negocio' value={operacion[OperacionLCLSFields.DescUnidadNegocio]} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FieldView label='Equipo Comercial' value={operacion[OperacionLCLSFields.DescSectorComercial]} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FieldView
                            label='Fecha de Solicitud'
                            value={operacion[OperacionLCLSFields.FechaSolicitud]
                                ? dateFormatter.toShortDate(operacion[OperacionLCLSFields.FechaSolicitud])
                                : undefined}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FieldView
                            label='Fecha de Vencimiento'
                            value={operacion[OperacionLCLSFields.FechaVencimiento]
                                ? dateFormatter.toShortDate(operacion[OperacionLCLSFields.FechaVencimiento])
                                : undefined}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FieldView label='Observaciones' value={operacion[OperacionLCLSFields.Observaciones]} />
                    </Grid>
                </SectionBox>
            )}
        </CardActions>
    );
}

export default SeccionLCLSDatosOperacion;